/* eslint-disable max-lines */
import { ErrorCode } from 'react-dropzone';
import { AUTH_TOO_MANY_REQUESTS, REACH_MAX_LOGIN_ATTEMPTS_CODE } from './error';

// HOME PAGE
export const DPD_ONLINE = 'Online';
export const SEND = 'Send';
export const SEND_NOW = 'Send now';
export const GET_QUOTE = 'Get quote';
export const SAME_DAY_DELIVERY = 'Need to send a parcel Same Day?';
export const COLLECTION_ADDRESS = 'Collection address';
export const DPD_GROUP_LTD = 'DPDgroup UK Ltd.';
export const ALL_RIGHTS_RESERVED = 'All rights reserved.';
export const DPD_REGISTERED_IN =
  'Registered in England and Wales: company no. 00732993.';
export const DPD_REGISTERED_OFFICE =
  'Registered office: Roebuck Lane, Smethwick, B66 1BY.';
export const SOCIAL_MEDIA = 'Social media';
export const WE_ACCEPT = 'We accept';
export const TERMS_AND_CONDITIONS = 'Terms & Conditions';
export const PRIVACY_NOTICE = 'Privacy Notice';
export const COOKIE_SETTINGS = 'Cookie Settings';
export const COOKIE_POLICY = 'Cookie Policy';
export const CYBER_SECURITY = 'Cyber Security';
export const POLICY_FOR_DISABLED_CONSUMERS =
  'Policy to support disabled consumers';
export const FUEL_ENERGY_SURCHARGE = 'Fuel and Energy Surcharge';
export const GEOPOST = 'Geopost';
export const EMAIL_LINK = 'Email link';
export const PICKUP_FINDER = 'Pickup Finder';
export const SIGN_OUT = 'Sign Out';
export const HELP = 'Help';
export const FAQS = 'FAQs';
export const PARCEL_DETAILS = 'Parcel details';
export const ADDRESS_DETAILS_HEADING = 'Address details';
export const CUSTOMS_DETAILS = 'Customs details';
export const PAYMENT = 'Payment';
export const SEND_PARCEL_HOME_SECTION = {
  TITLE: 'Send a parcel now from £2.99 (£2.49 plus VAT)',
  SHIP_TO: '',
  PRICE: (price, isInternational, priceWithVatRateText) =>
    isInternational ? `from £${price}` : `from ${priceWithVatRateText}`,
  SUBTITLE: 'Next Day delivery across the UK from {0}{1} excl. VAT',
  OPTIONS: [
    'A choice of drop-off or collection services',
    'Ship internationally from as little as {0}{1} excl. VAT',
    'Free real-time tracking on all parcels',
  ],
};

export const SEND_PARCEL_HOME_SECTION_DESCRIPTION = {
  TITLE: 'Send a parcel',
  SUBTITLE: 'Next Day delivery across the UK from {0}',
  OPTIONS: [
    'A choice of drop-off or collection services',
    'Ship internationally from as little as {0}{1}',
    'Free real-time tracking on all parcels',
    "'Excellent' Trustpilot rating based on over 2 million reviews",
  ],
};

export const CITYSPRINT_SAMEDAY_LABEL = 'Same Day Delivery';
export const CITYSPRINT_POWERED_BY = 'powered by';

// Hero section (Section One)
export const HERO_HEADLINE = 'Delivery done right.';
export const HERO_BENEFITS = [
  '1 hour delivery window',
  'Live tracking with driver details',
  "15 mins 'heads-up' before arrival",
];
export const TRUSTPILOT_EXCELLENT = 'Excellent';
export const TRUSTPILOT_REVIEWS = 'Over 2,400,000 reviews';

export const SERVICE_YOU_CAN_TRUST = 'You can trust DPD';
export const SERVICE_YOU_CAN_TRUST_DESCRIPTION =
  "With an 'Excellent' Trustpilot rating based on over 1.9 million reviews, you can be sure your parcel is in safe hands.";
export const SEND_YOUR_PARCEL_ANYWHERE =
  'Send your parcel anywhere in the world';
export const DPD_CAN_SHIP =
  'DPD can ship to over 200 countries worldwide, and when you send your parcel with DPD you can send it from as little as {0}{1}.';
export const DPD_CAN_SHIP_OPTIONS =
  'Whether you’re shipping to Bruges or Beijing, DPD’s international services have got you covered.';
export const LOCAL_DROP_OFF_AND_COLLECT =
  'Local Drop Off and Collection Services';
export const LOCAL_DROP_OFF_AND_COLLECT_DESCRIPTION =
  'DPD Online offers a range of local drop off and collection services, as well as free, real-time tracking.';
export const CONTACT_DPD_ONLINE = 'Contact DPD Online';
export const CONTACT_DPD_ONLINE_DESCRIPTION =
  'Have a question about your parcel delivery? Use our Help Centre to find the answer. Whether you need to switch from a collection to drop off service, report an issue, or find information on customs fees - our Help Centre has everything you need.';
export const FIND_YOUR_NEAREST_PICKUP_POINT =
  'Find Your Nearest DPD Online Drop Off';
export const FIND_YOUR_NEAREST_PICKUP_POINT_DESCRIPTION =
  'Click and drop your parcel at one of over 11,000 drop off points around the UK. Find your nearest DPD Online shop ';
export const HERE = 'here.';
export const SHIP_IN_BULK = 'Ship in Bulk';
export const SHIP_IN_BULK_DESCRIPTION =
  'If you’re shipping as a business or have multiple parcels to send, you can easily ship in bulk with DPD Online. Book your bulk delivery all in one go, saving yourself time and admin by only going through the booking process once.';
export const WHAT_IS_DPD_ONLINE = 'What is DPD Online?';
export const YOUR_RELIABLE_PARCEL = 'Your reliable parcel delivery solution.';
export const DPD_ONLINE_IS_YOUR =
  'DPD Online is your go-to choice for affordable and reliable parcel delivery. We understand the importance of trusting your chosen delivery service, which is why we provide free, real-time tracking for every delivery.';
export const WITH_OVER_DROP_OFF =
  'With over 11,000 drop-off points across the UK, finding a convenient location is easy.';
export const YOU_HAVE_ULTIMATE =
  'You have the ultimate flexibility whether you choose home or business collection for your convenience.';
export const PLUS_YOU_HAVE =
  'Plus you have a global reach with access to over 200 countries worldwide.';
export const FOR_MORE_INFORMATION =
  'For more information about sending parcels via DPD either in the UK or abroad, visit our ';
export const HELP_CENTRE = 'Help Centre';
export const BUY_NOW = 'Buy now';
export const SHIP_TO_$_FROM_$ = (country, price) =>
  `Ship to ${country} from £${price}`;

export const EMAIL_TEMPLATE_SUBJECT = 'Your DPD Order Details';
export const EMAIL_TEMPLATE_BODY_$ = link =>
  `Here is the link to your order: ${link}`;

// AUTH PAGES
export const SIGN_IN_WITH_EMAIL = 'Sign in using your email address';
export const SIGN_IN_WITH_EMAIL_DESCRIPTION =
  "By choosing to sign in using your email address, we'll just need to check if you already have an account or we'll give you the option to quickly create a new one.";
export const SIGN_IN = 'Sign In';
export const LOGOUT = 'Logout';
export const CHECK_YOUR_EMAIL = 'Check your email';
export const SEND_ON_EMAIL_$ = email => `We've sent an email to ${email}`;
export const CHECK_YOUR_EMAIL_DESCRIPTION =
  'This email will contain a magic link that will automatically sign you in.';
export const EMAIL_NOT_RECEIVE = `I didn't receive my email`;
export const BACK_TO_HOME = 'Back to home';
export const HOW_WE_USE_YOUR_DATA = 'This is how DPD will use your data:';
export const TO_KEEP_YOU_INFORMED = 'To keep you informed about your parcels';
export const NEVER_USE_YOUR_DATA_TO = 'DPD will never use your data to:';
export const ENSURE_OUR_SERVICES =
  'Ensure our services continue to meet your needs';
export const FOR_YOUR_PARCEL_PREFERENCES =
  'For your parcel preferences to be stored for a great delivery experience';
export const NEVER_SELL_YOUR_DATA =
  'We will never sell your data to any third parties';
export const NO_KEEP_DATA_LONGER_THAN_NEEDED =
  'We will never keep your data for longer than what is needed';
export const NO_SEND_MARKETING_INFO =
  'We will never use your data to send you marketing information';
export const NEXT = 'Next';
export const BACK = 'Back';
export const NEXT_STEP = 'Next step';
export const I_ACCEPT_TERMS = 'I agree to the Terms & Conditions';
export const ANOTHER_EMAIL_CHECK = 'We’ve sent another email, check your inbox';
export const CHECK_SPAM_TOO = 'Please be sure to check your spam folder too.';
export const RECEIVER_PICKUP_POINT = 'Receiver’s Pickup point';
export const CHANGE_YOUR_PICKUP_POINT = 'Change Your Pickup point';
export const SIGN_IN_WITH_EMAIL_EXPIRED =
  'Sorry, but it looks like the link you’re trying to use has now expired';
export const SIGN_IN_WITH_EMAIL_DESC_EXPIRED = `Don't worry, we can quickly send you a new magic link so that you can sign in to your DPD Online`;
export const PLEASE_PROVIDE_YOUR_PHONE =
  'Please provide your mobile number so we can keep you informed about your parcels';
export const VALIDATE_YOUR_MOBILE = 'Validate your mobile number';
export const ENTER_PIN = 'Enter a pin which is 6 digits long';
export const LOGIN_ERROR = 'Error while logging in';
export const RESEND_PIN = 'RESEND PIN';
export const RESEND_PIN_WITH_TIMER_$ = resendPinTimer =>
  `RESEND PIN (${resendPinTimer})`;
export const FOUND_ACCOUNT = 'We’ve found an account with those details:';
export const NEW_WEBSITE_LAUNCHED =
  'DPD Online has recently launched a brand new website with many exciting features to enhance your parcel delivery experience.';
export const MIGRATE = 'Migrate';
export const MIGRATE_DESCRIPTION =
  'We will seamlessly transfer all your saved information to the new website.';
export const MIGRATION_PROCESS_TIME =
  'This process will only take a few minutes and will happen in the background while you explore our new features.';

// TRACK PAGE
export const TRACK_YOUR_PARCEL = 'Track your parcel';
export const TRACK_A_PARCEL = 'Track a Parcel';
export const TRACK = 'Track';
export const FOUND_REFERENCE_NUMBER =
  'Your reference number can be found in your order confirmation email or on the printed label.';
export const DID_YOU_KNOW = 'Did you know?';
export const CUSTOMIZE_APP_TEXT =
  'That you can customise your delivery preferences in the DPD app';
export const DOWNLOAD_APP_TEXT = {
  DOWNLOAD_TODAY: 'Download the app today from the ',
  OR: ' or ',
  APPLE: 'Apple App Store',
  GOOGLE: 'Google Play store',
};
export const DOWNLOAD_ON_APPLE = 'DOWNLOAD ON APPLE APP STORE';
export const DOWNLOAD_ON_GOOGLE = 'DOWNLOAD ON GOOGLE PLAY';
export const SHARE_TRACKING_INFO = 'SHARE TRACKING INFO';
export const FETCHING_PARCEL_ERROR = 'Error while loading parcel';
export const FETCHING_COLLECTION_REFERENCE_ERROR =
  'No collection were found using that search criteria';
export const PLEASE_ENTER_VALID_$ = 'Please enter a valid {0} ';
export const PARCEL_NUMBER_IS_NOT_VALID = 'Your parcel number is not valid.';
export const PARCEL_NUMBER_MUST_CONTAIN_14_DIGITS =
  'The parcel number must contain exactly 14 digits';
export const PARCEL_NUMBER_IS_REQUIRED = 'Parcel number is required';
export const PARCEL_ACCESS_LEVEL = {
  FULL: 'F',
  GUEST: 'G',
};

// BASKET PAGE
export const YOUR_CART = 'Your Cart';
export const PARCEL_$ = parcelsQuantity =>
  `parcel${parcelsQuantity > 1 ? 's' : ''}`;
export const SHIPMENT_$ = shipmentQuantity =>
  `shipment${shipmentQuantity > 1 ? 's' : ''}`;
export const PARCEL_TO_$ = (contactName, parcelsQuantity) =>
  `${PARCEL_$(parcelsQuantity)} to ${contactName}`;
export const EDIT = 'Edit';
export const REMOVE = 'Remove';
export const PROCESS_TO_CHECKOUT = 'Proceed to Checkout';
export const PROCESS_$_SHIPMENT = shipmentsQuantity =>
  `Proceed to Checkout - ${shipmentsQuantity} ${SHIPMENT_$(shipmentsQuantity)}`;
export const REMOVE_FROM_CHECKOUT = 'Remove from checkout';
export const ADD_TO_CHECKOUT = 'Add to checkout';
export const WANT_TO_REMOVE_$ = itemToRemove =>
  `Are you sure you want to remove ${itemToRemove}?\nThis action cannot be undone once removed.`;
export const EMPTY_CARD = 'Your cart is empty';
export const TO_BE_DROPPED_OFF = 'to drop-off at your convenience';
export const TO_BE_COLLECTED = 'to be collected';
export const PARCEL = 'Parcel';
export const FREE = 'Free';
export const DEFAULT_PRICE = '0.00';
export const DROP_OFF_POINT = 'Drop off point:';
export const DROP_OFF_TO_PICKUP = 'Drop off to Pickup Point';
export const DIMENSIONS_$ = (height, length, width) =>
  `${height}cm x ${length}cm x ${width}cm`;
export const BUSINESS_ISSUE = 'Business issue';
export const PICKUP_POINT_ISSUE = 'Pickup Point issue';
export const INCORRECT_PICKUP_POINT_MSG =
  'Your selected pick up point is unavailable. Please select another pick up point.';
export const PLEASE_ENTER_RECEIVER_EMAIL = `Please enter the receiver's email address`;
export const PLEASE_ENTER_VALID_RECEIVER_EMAIL = `Please enter a valid receiver's email address`;
export const PLEASE_ENTER_RECEIVER_PHONE = `Please enter the receiver's phone number`;
export const PLEASE_ENTER_VALID_RECEIVER_PHONE = `Please enter a valid receiver's phone number`;
export const PLEASE_ENTER_RECEIVER_CONTACT_NAME = `Please enter the receiver's contact name`;
export const PLEASE_ENTER_YOUR_EMAIL = `Please enter your email address`;
export const PLEASE_ENTER_YOUR_VALID_EMAIL = `Please enter your valid email address`;
export const PLEASE_ENTER_YOUR_CONTACT_NAME = `Please enter your contact name`;
export const PLEASE_ENTER_YOUR_PHONE = `Please enter your phone number`;
export const PLEASE_ENTER_YOUR_VALID_PHONE = `Please enter your valid phone number`;
export const PLEASE_ENTER_RECEIVER_VAT = `Please enter the receiver's VAT number`;
export const PLEASE_ENTER_RECEIVER_PID = `Please enter the receiver's PID number`;
export const PLEASE_ENTER_RECEIVER_EORI = `Please enter the receiver's EORI number`;
export const PLEASE_ENTER_YOUR_EORI = 'Please enter your EORI number';
export const PLEASE_ENTER_YOUR_VALID_EORI =
  'Please enter your valid EORI number';

// CITYSPRINT
export const PLEASE_ENTER_FULL_NAME = 'Please enter full name';
export const PLEASE_ENTER_VALID_EMAIL = 'Please enter valid email address';
export const PLEASE_ENTER_VALID_PHONE = 'Please enter valid phone number';

// ORDER SUMMARY
export const ORDER_SUMMARY = 'Order summary';
export const VIEW_YOUR_ORDERS =
  'View your orders below. Please prepare your labels and retrieve your QR codes. This page will also be emailed to you.';
export const VIEW_INSTRUCTIONS = 'View instructions';

// VOUCHER
export const YOUR_VOUCHER = 'Your Voucher';
export const ENTER_VOUCHER = 'Enter your voucher code';
export const APPLY = 'Apply';
export const VOUCHER_APPLIED = 'Voucher applied';
export const INVALID_VOUCHER = 'Voucher code is invalid';
export const APPLIED_VOUCHER_$ = voucherCode =>
  `Voucher code '${voucherCode}' applied`;

// VALIDATION
export const REQUIRED = 'Required';
export const VALUE_IS_REQUIRED = 'Value is Required';
export const INVALID_POSTCODE = 'Invalid postcode';
export const LESS_OR_$_CHARACTERS = max => `Must be ${max} characters or less`;
export const GREATER_OR_$_CHARACTERS = min =>
  `Must be ${min} characters or greater`;
export const MAX_PARCEL_WEIGHT_$ = max => `Max weight ${max}kg`;
export const MAX_PARCEL_HEIGHT_$ = max => `Maximum parcel height ${max}cm`;
export const MAX_PARCEL_WIDTH_$ = max => `Maximum parcel width ${max}cm`;
export const MAX_PARCEL_LENGTH_$ = max => `Maximum parcel length ${max}cm`;
export const MAX_QUANTITY_$ = max => `(Maximum ${max})`;
export const CUSTOM_VALIDATION_ERROR_MESSAGES = {
  'postcode.bfpo.invalid':
    'The British Forces Post Office postcodes are not allowed',
  'string.pattern.base':
    'Invalid postal/zip code format. Please use a valid UK postal code format.',
  'postcode.country.invalid': 'Invalid postcode for selected country',
};
export const SHIPMENT_TOTAL_WEIGHT_ERROR =
  'Total Weight of all products cannot exceed {0}';
export const SHIPMENT_TOTAL_NUMBER_ERROR =
  'Total Number of Products cannot exceed {0}';
export const SHIPMENT_TOTAL_VALUE_ERROR =
  'Total Value of all products cannot exceed {0}';
//TODO: Products invalid error needs confirmation
export const PRODUCTS_ARE_INVALID = 'Please verify products details';
export const PRODUCT_IS_INVALID = 'Please verify product details';
export const RECIPIENT_TYPE = 'Recipient type';
export const SENDER_TYPE = 'Sender type';
export const PLEASE_ADD_PRODUCTS_DETAILS =
  'Please add product details to the customs details page';
export const WEIGHT_MUST_BE_LESS_THAN_30KG =
  'Weight (kg) must be less than or equal to 30kg';
export const WEIGHT_MUST_BE_MORE_THAN_0KG = 'Weight (kg) must be more than 0kg';

// ERRORS
export const LOST_INTERNET_CONNECTION =
  'Sorry, it looks like you’ve lost connection. Please connect to the internet and try again';

export const REFRESH = 'Refresh';
export const TOTAL_QUANTITY_ERROR_$ =
  'Total quantity must not be more than {0}';
export const TOTAL_VALUE_ERROR_$ = 'Total value must not be more than £{0}';
export const TOTAL_WEIGHT_ERROR_$ =
  'Total weight for collection must not be more than {0}kg';
export const EXPIRED_LABEL_OR_QR_ERROR =
  "It looks like you're trying to access a label or QR code that's expired. They are only available for 14 days from when they're created";

// BUTTONS
export const DIRECTIONS = 'Directions';
export const CANCEL = 'Cancel';
export const CLOSE = 'CLOSE';

// PICKUP POINTER
export const OPENS = 'Opens';
export const CLOSES = 'Closes';
export const CLOSED_FOR_LUNCH = 'Closed for lunch';
export const SHOP = 'Shop';
export const LOCKER = 'Locker';
export const MILES = 'mi';
export const CLOSED = 'Closed';
export const OPEN = 'Open';
export const CLOSED_FOR_LUNCH_BETWEEN = 'Closed for lunch between';
export const SELECT = 'Select';
export const PICKUP_POINT_LIST_TITLE = 'Pickup Point Finder';
export const SELECTED_PICKUP_POINT = 'Select Pickup Point';
export const MAP_VIEW = 'Map view';
export const LIST_VIEW = 'List view';

// SEARCH
export const NO_RESULT = {
  title: 'Sorry,',
  description: 'There are no Pickup Points available in this area.',
};
export const NO_SEARCH_SEARCH_RESULT = 'No search results found';

// PARCEL_DETAILS
export const WHERE_YOUR_PARCEL_GOES = 'Where is your parcel going to?';
export const CHOOSE_FROM_ADDRESS_BOOK = 'Choose From Address Book';
export const WHERE_YOUR_PARCEL_FROM = 'Where are you sending it from?';
export const HOW_BIG_IS_YOUR_PARCEL = 'How big is your parcel?';
export const VIEW_MAX_PARCEL_SIZES = 'View maximum parcel sizes';
export const ADD_ANOTHER_PARCEL = 'Add another parcel';
export const DELETE_PARCEL = 'Delete parcel';
export const WHERE_DELIVER_PARCEL_TO = 'Where should we deliver your parcel?';
export const VIEW_NEARBY_PICKUPS = 'View nearby DPD Pickup points';
export const SELECT_DPD_PICKUP_POINT = 'Select DPD Pickup Point';
export const DIRECT_TO_PICKUP = 'Direct to Pickup Point';
export const DIRECT_TO_PICKUP_DESCRIPTION =
  'Send your parcel directly to one of our Pickup Points for the recipient to collect';
export const MOST_POPULAR = 'Most popular';
export const RECOMMENDED = 'Recommended';
export const DELIVER_TO_RECIPIENT = 'Deliver to the recipient';
export const DELIVER_TO_RECIPIENT_DESCRIPTION =
  'Your parcel will be delivered directly to the recipient’s address';
export const WHEN_DELIVER = 'When would you like it to arrive?';
export const WHEN_ARRIVE = 'When will it arrive?';
export const WOULD_YOU_LIKE_COLLECTION =
  'Would you like us to collect your parcel?';
export const YES_COLLECT = 'Yes, collect my parcel';
export const YES_COLLECT_DESCRIPTION =
  'We will collect your parcel at the address you have provided.';
export const NO_DROP_OFF = 'No, I’ll drop it off';
export const NO_DROP_OFF_DESCRIPTION =
  'You can drop off your parcel at any of our Pickup Points near to you.';
export const COLLECTION_DATE_HEADER = 'When would you like us to collect?';
export const WOULD_YOU_LIKE_INSURANCE = 'Would you like to add extended cover?';
export const LIABILITY_COVER_FOR_YOUR_PARCEL =
  'Liability cover for your parcel';
export const MAX_PARCEL_SIZES = 'Maximum Parcel Sizes';
export const SHOP_SIZES_HEADING = 'Shops - Drop-off or collection';
export const SHOP_SIZES_TEXT =
  "The longest side of your box or bag, plus the next-longest side added together, can't be more than 120cm. Max weight is 20kg.";
export const LOCKER_SIZES_HEADING = 'Locker - Drop-off or collection';
export const LOCKER_SIZES_TEXT =
  'The biggest box or bag that will fit in the locker measures 37cm width x 68cm height x 55cm depth. Max weight is 20kg.';
export const HOME_SIZES_DOMESTIC_HEADING =
  'Home - Domestic Collection and delivery';
export const HOME_SIZES_DOMESTIC_TEXT =
  'The longest size of your box or bag can’t be more than 200cm. The maximum girth, which is calculated as length + height + width, is 270cm. Max weight is 30kg.';
export const HOME_SIZES_INTERNATIONAL_HEADING =
  'Home - International Collection and delivery';
export const HOME_SIZES_INTERNATIONAL_TEXT = `The longest side of your box or bag can't be more than 175cm. The maximum girth, which is calculated as length + (2 x height) + (2 x width), is service-dependent and ranges from 90cm to 330cm. Max weight is 31.5kg.`; // NOTE: What with this message?
export const AVAILABLE_SERVICES = 'Available services';
export const WE_ARE_CALCULATING_SERVICES =
  'We’re just calculating our best services for you';
export const WEIGHT = 'Weight';
export const QUANTITY = 'Quantity';
export const QUANTITY_DESCRIPTION =
  'Are you sending multiples of the same parcel?';
export const VALUE = 'Value';
export const VALUE_DESCRIPTION =
  'What is the value of the contents of your parcel?';
export const CHOSEN_PICKUP_POINT = 'Your chosen Pickup Point:';
export const HEIGHT = 'Height';
export const WIDTH = 'Width';
export const LENGTH = 'Length';
export const PARCEL_FETCHING_ERROR = 'Error while loading parcel details';
export const FETCHING_ERROR = 'Error while loading';
export const SAME_DAY_POSTCODES_REQUIRED =
  'Please choose destination and collection addresses with valid postcodes for Same Day delivery.';
export const NO_SAME_DAY_SERVICES_AVAILABLE_FOR_THE_GIVEN_POSTCODES =
  'No same day services available for the given postcodes';
export const NO_NETWORKS_ERROR = `We're having trouble finding a shipping option for this package. Please visit our help pages for more information`;
export const NO_NETWORKS_ERROR_EXCEEDS_PARAM = `We can’t find a shipping option for your package because it exceeds our maximum weight or dimensions. Please adjust your parcel’s information or visit our Help page for more support`;
export const INVALID_NETWORK_SELECTED =
  'The selected shipping option is unavailable for this package, please review your shipment details or visit our Help page for more support';
export const FAILED_TO_SAVE_BASKET =
  'Failed to save basket item. Please try again';
export const FAILED_TO_DELETE_BASKET_ITEM =
  'Failed to delete basket item. Please try again';
export const FAILED_TO_GET_$ = 'Failed to get {0}. Please try again';
export const YOUR_SESSION_HAS_EXPIRED = 'Your session has expired.';
export const YOUR_SESSION_HAS_EXPIRED_REFRESH_TO_CONTINUE = `Your session has expired. Please refresh to continue.`;
export const GBP = 'GBP';
export const CURRENCY_SYMBOLS = {
  GBP: '£',
  EUR: '€',
  USD: '$',
};
export const TRY_AGAIN = 'Try again';
export const EMAIL = 'email';
export const PHONE_NUMBER = 'phone number';
export const MOBILE_NUMBER = 'mobile number';
export const EORI = 'EORI';
export const GB = 'GB';
export const IE = 'IE';
export const DATE_CANNOT_BE_IN_THE_PAST = 'Date cannot be in the past';
export const COLLECTION_DATE_TIME_IN_THE_PAST =
  'That collection date and time is 1 hour in the past. Please choose a future date and time.';
export const INVALID_COLLECTION_DATE =
  'Unfortunately, the collection date for this shipment has already passed. Please update the collection date and try again.';
export const ADD_COMMODITY_CODE = 'Add Commodity Code';
export const PRODUCT_DESCRIPTION = 'Product description';
export const PRODUCT_QUANTITY = 'Qty';
export const PRODUCT_UNIT_VALUE_$ = 'Unit Value ({0})';
export const TOTAL_PRODUCTS = 'Total Products';
export const TOTAL_WEIGHT = 'Total Weight (kg)';
export const TOTAL_VALUE_$ = 'Total Value ({0})';
export const NO_COLLECTION_DATES_AVAILABLE = 'No collection dates available'; // TODO: Verify error message
export const PLEASE_VERIFY_BILLING_ADDRESS =
  'Please verify your billing address details';

// PAYMENT
export const PURCHASE_WIDGET = {
  CHECKOUT: 'PROCEED TO CHECKOUT',
  CLOSE: 'CLOSE',
  SUBMIT: 'Submit',
  WIDGET_CREATE_ERROR: 'Payment Widget Create Error',
  CLIENT_TOKEN_ERROR:
    'It looks like your session has expired. To continue, please refresh the page and begin the checkout process from the start. We apologise for any inconvenience.',
  TOKENIZATION_ERROR: 'Tokenization Error',
  PAYMENT_ERROR: 'Payment Error',
  LIABILITY_ERROR: 'Liability Did Not Shift',
  PAYMENT_CURRENCY_CODE: 'GBP',
  MERCHANT_NAME: 'DPD group UK',
  MERCHANT_ID: 'dpdonlineukGBP',
  TOTAL_PRICE_STATUS: 'FINAL',
  ALLOWED_PAYMENT_METHOD_TYPE: 'CARD',
  BILLING_ADDRESS_PARAMETERS_FORMAT: 'FULL',
  ALLOWED_CARD_NETWORKS: ['VISA', 'MASTERCARD'],
};

export const VIEW_CART = 'VIEW CART';

// SUMMARY DETAILS
export const SUMMARY_DETAILS = {
  TITLE: 'Your Summary',
  STANDARD_DELIVERY: 'Standard next day delivery',
  COLLECT_PARCEL: 'Collect my parcel',
  DELIVER_RECIPIENT: 'Deliver to the recipient',
  INSURANCE_COVER: 'Extended cover',
  TOTAL: 'Total',
  INC_VAT: '(inc. VAT)',
  VAT: 'VAT',
};

// SHIPPING DETAILS
export const SHIPPING_DETAILS = {
  TITLE: 'Shipping details',
  SENDER: 'Sender',
  RECEIVER: 'Receiver',
};

// SALES CONDITIONS
export const SALES_CONDITIONS = {
  TITLE: 'Sales conditions',
  DUTY_TAX_TITLE: 'Important Duty and Tax Information',
  ACCEPT_THE: 'I accept the ',
  CONFIRM_THAT_MY_SHIPMENT: 'I confirm that my shipment doesn’t contain any ',
  TERMS_AND_CONDITIONS: 'Terms & Conditions',
  INFORMATION_COLLECTING:
    'The information collected on this form is processed by DPDgroup UK for the delivery of your parcel.',
  MORE_ABOUT_DATA_MANAGEMENT:
    'Find out more about the management of your data.',
  IF_YOU_LIKE_TO_RECEIVE:
    'If you would like to receive offers and discounts for shipping with DPD only, please tick',
  PROHIBITED_ITEMS: 'Prohibited Goods',
  DUTY_AND_TAX_INFO: {
    BY_PLACING_THIS_ORDER: 'By placing this order, you have confirmed that:',
    YOU_HAVE_READ: 'you have read, understood and agreed to our ',
    WE_RESERVE:
      '. We\n' +
      'reserve the right to refuse to collect or accept any goods into our network\n' +
      'which are inadequately or incorrectly packaged for the Service that you\n' +
      'have purchased; and',
    YOU_ARE_NOT_SENDING:
      'you are not sending any item(s) which are included on the ',
    LIST_SENDING: ` list. The sending of items which are included on the Prohibited Items list
shall be considered a breach of the Terms and Conditions. You will not be able to claim in the event of any loss or damage to any goods which are Prohibited Items, and any extended cover purchased in connection to such goods shall be null and void.`,
    VIEW_OUR: 'View our ',
    TO_UNDERSTAND: ' to understand more about how we use your personal data.',
    PRIVACY_POLICY: 'Privacy Policy',
    TERMS_AND_CONDITIONS: 'Terms & Conditions',
    PROHIBITED_ITEMS: 'Prohibited Items',
    DUTIES_AND_TAXES:
      'Duties and Taxes (including any additional customs costs) may be applicable for any parcel(s) sent outside of Great Britain. The amount of Duties and Taxes payable will depend on the value, the item(s), the purpose and the destination of the shipment. All parcels sent via DPD Online shall be delivered using the Incoterm “Delivered At Place” (DAP). This means that any Duties and Taxes owed in relation to the shipment must be paid by the recipient.',
    IF_DUTIES_AND_TAXES:
      'If Duties and Taxes are owed, customs officials of the destination country will contact the recipient for payment before release of the parcel for delivery. Failure to pay the applicable Duties and Taxes may result in the parcel being held, destroyed or returned to you.',
  },
};

export const PROHIBITED_MODAL = {
  PROHIBITED_ITEMS: 'Prohibited Goods',
  PROHIBITED_ITEMS_DESCRIPTION:
    'Certain items are prohibited from being carried on any of our services in accordance with our ',
  ORDER_CANCELLATION_WARNING:
    'We do not accept the items listed below or any item similar in description or content and shipping any of these Prohibited Goods may result in cancellation of your order without notice.',
  SPECIAL_PROVISIONS: 'Special Provisions',
  TERMS_AND_CONDITIONS: 'Terms and Conditions.',
};

// PRODUCTS & SERVICES
export const PRODUCT_AND_SERVICES = {
  MAIN_OVERLINE_HEADER: 'July 2024 | International Services',
  UK_TO_FRANCE_TITLE: 'UK to France? Choose DPD!',
  PRICE_START_FROM: `Prices start from £{0} exc VAT`,
  THE_CHOICE_IS_YOURS:
    'The choice is yours! Schedule a home collection or drop off at any of our 10,000+ DPD Pickup locations.',
  LISTS_WITH_TITLES: [
    {
      TITLE: 'UK to France? Choose DPD!',
      LIST: [
        'Stress-free shipping: Our user-friendly website lets you compare express and economy options in seconds. Find the perfect balance for your budget and speed needs.',
        "Trusted by millions: We're a leading choice for parcel delivery across Europe.",
        'Nationwide coverage: Send your parcel anywhere in France, from bustling Paris to the sunny southern coast.',
        'Get a quote: The exact cost depends on size, weight, and service, but we offer competitive rates for all options.',
      ],
    },
    {
      TITLE: "Sending to France? Here's what you need to know about customs:",
      LIST: [
        'Gifts under £39/€45 (including shipping) are VAT-free.',
        'Parcels over £39 or from online marketplaces incur a 20% EU VAT.',
        'Reduced VAT rates (10% or 5.5%) may apply for specific items.',
        'For details on reduced VAT rates, please visit the French customs website.',
      ],
    },
    {
      TITLE: 'Smooth Sailing Through French Customs:',
      LIST: [
        'Know Your Stuff: During booking, you might be asked for a commodity code (HS/Tariff code). This helps customs identify your items for safety, legality, and potential duties.',
        "Finding Your Code: We'll guide you through finding the right code during the booking process.",
        'Need Help? Unsure about customs information? Check our detailed advice page or contact our friendly team for any questions.',
      ],
    },
  ],
  MEDIA_CARD: {
    EXC_VAT: 'exc VAT',
    INC_VAT: '£{0} inc. VAT (parcels up to 20kg)',
    CHOOSE_THIS_SERVICE: 'Choose this service',
  },
  HELPFUL_DETAILS: {
    TITLE: 'Here are some additional details you might find helpful:',
    DETAILS: [
      {
        TITLE: 'How fast can I get a parcel to France?',
        DESCRIPTION:
          'Fast & affordable France delivery! Standard options reach France in 3-4 days, or choose express delivery for super-speedy arrivals in 2 days.',
      },
      {
        TITLE:
          "Don't sweat the French address! Check out our guide for hassle-free parcel delivery.",
        DESCRIPTION:
          'France or UK? Addressing is almost the same! Get it right with our guide.',
      },
      {
        TITLE:
          'Track your DPD parcel in France! Enter your tracking number for real-time updates.',
        DESCRIPTION:
          'Say goodbye to delivery guesswork! DPD Predict for France provides the receiver with a one-hour delivery window for a stress-free experience.',
      },
      {
        TITLE:
          'Check before you ship to France: See a list of restricted items',
        DESCRIPTION:
          'Planning your France shipment? We can help! Here are some items that require extra attention:\n' +
          '\n' +
          'Active mobile phones from outside the EU: These may require additional processing.\n' +
          'Batteries: Check regulations for specific types.\n' +
          'Credit/debit/cash cards: Not recommended for international shipping due to security concerns.\n' +
          'Fishing rods: May require special declarations.\n' +
          'Perishable goods: Generally not allowed due to customs regulations.\n' +
          '\n' +
          'For a complete list and regulations, please see:  Our Prohibited Goods page  or HM Revenue and Customs.',
      },
    ],
  },
};

// ADDRESS DETAILS
export const ADDRESS_DETAILS = {
  DETAILS_TITLE: 'Your details',
  CUSTOMS_DETAILS: 'Customs details',
  COMPANY_NAME: 'Company name',
  CONTACT_NAME: 'Your full name',
  EMAIL: 'Your email address',
  EMAIL_CONFIRM: 'Confirm email address',
  PHONE: 'Your phone number',
  SAVE_FOR_NEXT_TIME: 'Save this information for next time',
  RECEIVER_DETAILS_TITLE: 'Receiver’s details',
  RECEIVER_CONTACT_NAME: 'Receiver’s full name',
  RECEIVER_EMAIL: 'Receiver’s email address',
  RECEIVER_PHONE: 'Receiver’s phone number',
  COLLECT_NOTATION: 'Note, your address will be used as your return address.',
};

export const ADDRESS_WIDGET = {
  EDIT: 'Edit Address',
};

export const ADDRESS_LOOKUP = {
  LOOKUP_PLACEHOLDER: 'Start entering your address',
  LABEL: 'Address search',
  LOOKUP_ERROR: 'Address lookup error',
};

export const AT_RISK_TITLE =
  "Are the items in your parcel 'at risk' of onward movement to or sale to businesses or consumers in the European Union (EU)?";
export const AT_RISK_TEXT =
  "When shipping goods to Northern Ireland, a declaration is required. DPD will make the declaration on your behalf but in order to do so you will need to inform us whether the goods shipped will remain in Northern Ireland and are 'not at risk'  or if they are  'at risk' to be sold or sent onward to the EU. DPD will need to complete different declaration processes in each scenario. If you are unsure select 'yes' to ensure your parcel is handled correctly and compliantly.";

// ADDRESS BOOK
export const ADDRESS_BOOK_MODAL = {
  TITLE: 'Address Book',
};
export const SELECT_ADDRESS = 'Select';

export const PICKUP_MODAL = {
  TITLE: 'Find your nearest Pickup Point',
  LOOKUP_PLACEHOLDER: 'Start typing a postcode',
  LOOKUP_ERROR: 'Address lookup error',
};

export const ADDRESSES_POPULATING = 'Your addresses are still being populated';
export const ADDRESSES_POPULATING_DESCRIPTION =
  'Due to the amount of addresses you have in your account please be aware that they may take a while to be added to your address book. We are sorry for any inconvenience this may cause.';

// USER PREFERENCES
export const USER_PREFERENCES_SECTIONS = {
  OVERVIEW: 'Overview',
  ACCOUNT: 'Account',
  ADDRESSES: 'Addresses',
  ORDERS: 'Orders',
};

export const COMMODITY_FINDER = {
  TITLE: 'Commodity code finder',
  SUBTITLE: 'e.g. Leather Shoes, Toys, Women’s Blouse',
  SEARCH_BUTTON: 'Search',
  LOAD_MORE: 'Load more',
  NO_RESULT: {
    TITLE: 'No search results found',
    SUBTITLE: 'Sorry, but nothing matched your search criteria.',
    DESCRIPTION: 'Please try again with different or less specific keywords.',
  },
  INVALID_CODE: {
    TITLE: 'Commodity Code Error',
    SUBTITLE:
      'Commodity code is prohibited to destination country, please enter a valid commodity code',
    LINK: `For more support in classifying products visit `,
    DESCRIPTION:
      'DPD accepts no liability for any inaccuracy of a duty calculation or a delay or return of a parcel as the consequence of the code supplied.',
    BUTTON: 'Ok',
  },
};

export const ADDRESSES_SECTION = {
  SECTION_TITLE: 'Your Addresses',
  NO_ADDRESSES_ADDED: "You haven't added any addresses",
  NO_ADDRESSES_FOUND: 'Sorry, there were no results for your query',
  BULK_UPLOAD: 'Bulk Upload',
  ADD_NEW_ADDRESS: 'Add new address',
  TABLE_ACTIONS: {
    EDIT: 'View / Edit',
    DELETE: 'Delete',
  },
  SIDEBAR_FORM: {
    ADD_NEW_ADDRESS: 'Add New Address',
    EDIT_ADDRESS: 'Edit Address',
    CANCEL: 'Cancel',
    SAVE: 'Save',
  },
  //TODO: agree notification messages
  NOTIFICATIONS: {
    SUCCESS: {
      CREATE: 'Address added',
      UPDATE: 'Address updated',
      DELETE: 'Address deleted',
      BULK_UPLOAD: 'Bulk upload complete',
    },
    ERROR: {
      CREATE: 'Error during creation',
      UPDATE: 'Error during update',
      DELETE: 'Error during deletion',
      RETRIEVE: 'Something went wrong. Please try again later',
      DOWNLOAD_TEMPLATE:
        'Error during template downloading. Please try again later',
      FETCHING_ERROR: 'Error while loading address book',
      CONFLICT: 'Address book already exists',
      CREATE_ADDRESS_BOOK: 'Error during address book creation',
    },
  },
  DELETE_MODAL: {
    TITLE: 'Confirm Deletion',
    TEXT_$: WANT_TO_REMOVE_$,
    CANCEL_BUTTON: 'Cancel',
    DELETE_BUTTON: 'Delete',
  },
  BULK_UPLOAD_MODAL: {
    TITLE: 'Bulk upload',
    DOWNLOAD_TEMPLATE_CSV_TITLE: 'Download a Template (CSV)',
    DOWNLOAD_TEMPLATE_CSV_TEXT:
      'Click the button below to download a sample CSV file formatted for uploading addresses. This file includes column headers to guide you on filling in your specific address data.',
    UPLOAD_TEMPLATE_CSV_TITLE: 'Upload Your CSV',
    UPLOAD_TEMPLATE_CSV_TEXT:
      'Once you\'ve filled out the template with your addresses, click "Choose File" to select your CSV file and upload it here.',
    LOADING: 'Upload in progress...',
    ERROR: 'Something went wrong',
    CANCEL_ERROR: 'Bulk upload was canceled',
    BUTTONS: {
      DOWNLOAD_TEMPLATE: 'Download template',
      CHOOSE_FILE: 'Choose file',
      CANCEL: 'Cancel',
      TRY_AGAIN: 'Try again',
    },
  },
  SEARCH: {
    BUTTON: 'Search',
    LABEL: 'Search address book',
  },
};

export const ORDERS_SECTION = {
  SECTION_TITLE: 'Your Orders',
  NO_ORDERS_ADDED: 'No orders to show',
  TABLE_ACTIONS: {
    VIEW_ORDER: 'View Order',
    SEND_AGAIN: 'Send Again',
    PRINT_INVOICE: 'Print Invoice',
    CONTACT_US: 'Contact Us',
  },
  NOTIFICATIONS: {
    COPY_TO_CLIPBOARD_SUCCESS: 'Parcel number copied to clipboard',
    FETCHING_ERROR: 'Error while loading orders',
    DUPLICATE_ORDER_ERROR: 'Error while duplicating order',
  },
  ERROR: 'Something went wrong',
};

export const ORDER_DETAILS = {
  RECIPIENT_ADDRESS: 'Recipient Address',
  SENDERS_ADDRESS: "Sender's Address",
  HISTORY: 'History',
  DELIVERING_IN_AN_ALL_ELECTRIC_VEHICLE:
    'Proudly delivering in an all-electric vehicle',
  UNKNOWN: 'Unknown',
  TRACKING: 'Tracking',
  GALLERY_TITLE: 'Photo on delivery images',
  issueDelayDaysMessage_$: (issueDelayDays, issueName) =>
    `There is currently a ${issueDelayDays} day delay in your area due to ${issueName}.`,
  issueDelayMessage_$: issueName =>
    `There are currently delays in your area due to ${issueName}.`,
  DOWNLOAD: 'Download',
  LABEL_PDF: 'Label PDF',
  BARCODE_PDF: 'Barcode PDF',
  PROFORMA_INVOICE_PDF: 'Proforma Invoice PDF',
  INVOICE_PDF: 'Invoice PDF',
  INVOICE_CSV: 'Invoice CSV',
  SEND_AGAIN: 'Send Again',
  BACK_TO_ORDERS: 'Back to orders',
};

export const FILE_FORMAT = {
  PDF: 'pdf',
  CSV: 'csv',
};

export const AUTH = {
  LOGOUT_FAILED: 'Logout failed',
  SIGNOUT_ERROR: 'Sign Out error',
  SEND_MAGIC_LINK_ERROR: 'Send Magic Link error',
};

const AUTH_RETRY_AFTER_TITLE =
  'Sorry, you’ve made too many attempts to sign in';
const AUTH_RETRY_AFTER_DESCRIPTION_$ = time =>
  `It looks like you've tried to sign in too many times. Please try again ${
    time ? `in ${time}` : 'later'
  }.`;
export const TOO_MANY_REQUESTS_MESSAGE = time =>
  `Too many requests. Please try again ${time ? `in ${time}` : 'later'}`;

export const ERROR_MESSAGES_MAP = {
  [REACH_MAX_LOGIN_ATTEMPTS_CODE]: {
    title: AUTH_RETRY_AFTER_TITLE,
    description: AUTH_RETRY_AFTER_DESCRIPTION_$,
  },
  [AUTH_TOO_MANY_REQUESTS]: {
    title: AUTH_RETRY_AFTER_TITLE,
    description: AUTH_RETRY_AFTER_DESCRIPTION_$,
  },
  default: {
    title: 'An unknown error occurred',
  },
};

export const ACCOUNT_DETAILS_SECTION = {
  ACCOUNT_DETAILS: 'Account Details',
  SNACKBAR_MESSAGES: {
    SUCCESS: 'Preference saved',
    FAILED: 'Preference failed to save. Please try again',
  },
  SAVE: 'Save',
};

export const COMMUNICATION_PREFERENCES_SECTION = {
  COMMUNICATION_PREFERENCES: 'Communication Preferences',
  MARKETING_COMMUNICATION: {
    TITLE: 'Marketing Communications',
    DESCRIPTION:
      'Be the first to know about exclusive deals and limited-time offers. Plus, get valuable marketing tips to get the most out of our products and services.',
  },
  TRACKING_UPDATES: {
    TITLE: 'Tracking Updates',
    DESCRIPTION:
      "Stay in the loop! We'll keep you updated on your order with clear tracking information, delivery notifications, and any relevant account updates.",
  },
  SNACKBAR_MESSAGES: {
    SUCCESS: 'Communication preference saved',
    FAILED: 'Communication preference failed to save. Please try again',
  },
};

export const DELETE_ACCOUNT_SECTION = {
  DELETE_ACCOUNT: 'Delete Account',
  WE_UNDERSTAND_WARNING:
    'We understand you might not need your DPD Online account anymore. Deleting your account will permanently remove your profile and past order history, along with any pre-pay balance (no refunds after deletion).',
  ONCE_DELETED_WARNING:
    'Once deleted, you won\'t be able to recover your account or information. Click "Delete My Account" to confirm. This action is permanent.',
  DELETE_MY_ACCOUNT: 'Delete my account',
  DELETE_ACCOUNT_MODAL: {
    CONFIRM_DELETION: 'Confirm Deletion',
    DELETION_WARNING:
      "Once deleted, you won't be able to recover your account or information.",
    CANCEL: 'Cancel',
    DELETE: 'Delete',
  },
};

export const OVERVIEW_SECTION = {
  GREETINGS_$: name => `Hi ${name}`,
  TRACK_PARCELS:
    'Easily track your parcels in real-time, view past orders and manage saved addresses for quick rebooking.',
  YOUR_RECENT_ORDERS: 'Your Recent Orders',
  VIEW_ALL: 'VIEW ALL',
  YOUR_ADDRESSES: 'Your Addresses',
  ACCOUNT_SUMMARY: 'Account Summary',
  MANAGE_ACCOUNT: 'MANAGE ACCOUNT',
  NAME: 'Name',
  EMAIL_ADDRESS: 'Email Address',
  PHONE_NUMBER: 'Phone Number',
};

export const CONFIRMATION = {
  TITLE: 'How to Use Your Digital Label',
  THANK_YOU: 'Thank you',
  ALL_DONE: 'you’re all done.',
  HOME_COLLECTION_INSTRUCTIONS: 'Home collection instructions',
  DROP_OFF_INSTRUCTION: 'Drop-off instructions',
  SHARE_PARCEL_INFO: 'Share parcel info',
  DOWNLOAD_INVOICE: 'Download invoice',
  DOWNLOAD_LABEL_TO_PRINT: 'Download label to print',
  DOWNLOAD_YOUR_LABELS: 'Download your labels',
  DOWNLOAD_QR_CODES: 'Download QR codes',
  DOWNLOAD_LABEL_AS_PDF: 'Download label as PDF',
  SEND_ANOTHER_PARCEL: 'Send another parcel',
  PARCEL_PASS: 'Parcel Pass',
  SHARE_MODAL_TITLE: 'Share parcel info',
  COPY_LINK: 'Copy link',
  DOWNLOAD_ERROR: 'Failed to download label:',
  ERROR: 'Something went wrong',
  VIEW_QR_CODE: 'VIEW QR CODE',
  VIEW_LABEL: 'VIEW LABEL',
  SHOW_NEAREST_PICKUP_POINTS: 'Show nearest pickup points',
  STEPS: {
    PACK_ITEM: 'Pack your item to avoid any transport damage.',
    PRINT_LABEL:
      'Print your label and stick it on the parcel. Make sure to cover other labels on the package.',
    BRING_PARCEL_TO_DROPOFF: 'Bring the parcel to a drop-off of your choice.',
    DRIVER_COLLECT:
      'The driver will collect your parcel on your selected day between 8:00 and 17:00.',
    TAKE_PARCEL_TO_PICKUP:
      'Take your parcel(s) to your preferred DPD drop-off location.',
    PRESENT_QR_CODE:
      'Present your digital label on your phone or tablet to the shop assistant.',
    ASSISTANT_SCAN:
      'The assistant will scan your digital label and apply a physical barcode to your parcel.',
    RECEIVE_RECEIPT:
      "You'll receive a receipt with a tracking number to follow your parcel's journey.",
  },
  INTERNATIONAL: {
    INFO_TITLE: 'Important note',
    INFO_DESCRIPTION_PROFORMA_INVOICE:
      'For a shipment abroad, pro-forma invoice in triplicate must be attached to the parcel. Each copy must be signed in the original.',
    INFO_DESCRIPTION_COMMERCIAL_INVOICE:
      'For a shipment abroad, commercial invoice in triplicate must be attached to the parcel. Each copy must be signed in the original.',
    CREATE_PROFORMA_INVOICE: 'Create pro-forma invoice',
    CREATE_COMMERCIAL_INVOICE: 'Create commercial invoice',
  },
};

export const PARCEL_INSURANCE = {
  TITLE: 'Would you like to add extended cover?',
  DESCRIPTION: (additionalProtectionPrice, coveredValue) => {
    if (coveredValue) {
      return `The value of your parcel is covered up to £${Number(
        coveredValue
      ).toFixed(2)} amount`;
    } else if (additionalProtectionPrice) {
      return `The full value of your parcel is not covered. Would you like to add additional protection for £${Number(
        additionalProtectionPrice
      ).toFixed(2)}?`;
    } else {
      return 'The full value of your parcel is covered.';
    }
  },
  ADD_PROTECTION: 'Add protection',
  REMOVE_PROTECTION: 'Remove protection',
};

export const ADD_TO_WALLET = {
  GOOGLE: 'ADD TO GOOGLE WALLET',
  APPLE: 'ADD TO APPLE WALLET',
};

export const OS = {
  IOS: 'iOS',
  ANDROID: 'Android',
};

export const COPIED_TO_CLIPBOARD = 'Copied to clipboard';

export const DISMISS = 'Dismiss';

// Help pages
export const HOW_CAN_WE_HELP = 'How can we help';
export const HELP_SELECT_SERVICE = 'Select your service';
export const HELP_SAMEDAY_SERVICE_TITLE = 'Same Day Service';
export const HELP_SAMEDAY_SERVICE_BODY =
  'Get support for Same Day delivery powered by CitySprint';
export const HELP_DPD_ONLINE_SUPPORT_TITLE = 'DPD Online Support';
export const HELP_DPD_ONLINE_SUPPORT_BODY =
  'Get help with your DPD Online parcel shipments';
export const HELP_SAMEDAY_BOOKING_REFERENCE_TITLE =
  'Enter your booking reference below';
export const HELP_SAMEDAY_BOOKING_REFERENCE_LABEL = 'Booking reference';
export const HELP_SAMEDAY_BOOKING_REFERENCE_REQUIRED = `${HELP_SAMEDAY_BOOKING_REFERENCE_LABEL} is required`;
export const HELP_SAMEDAY_BOOKING_REFERENCE_INVALID =
  'Booking reference must start with CS and be more than 4 characters';
export const HELP_SAMEDAY_DELIVERY_POSTCODE_LABEL = 'Delivery post code';
export const HELP_SAMEDAY_DELIVERY_POSTCODE_REQUIRED = `${HELP_SAMEDAY_DELIVERY_POSTCODE_LABEL} is required`;
export const HELP_SAMEDAY_CONTACT_TITLE = 'Contact the Same Day Team';
export const HELP_SAMEDAY_CONTACT_INTRO =
  'Thanks for providing your details. Your delivery is handled by our Same Day partner, CitySprint.';
export const HELP_SAMEDAY_CONTACT_BODY_PREFIX =
  'Get in touch with the CitySprint team to resolve your query on';
export const HELP_SAMEDAY_CONTACT_BODY_SUFFIX =
  '. Please have your booking reference handy. Lines open 24-7';
export const HELP_SAMEDAY_BOOKING_NOT_FOUND =
  'We could not find a booking with those details.';
export const CHOOSE_ONE_OF_OPTIONS = 'Choose one of the options';
export const CONTACT_US = 'Contact Us';
export const SEARCH = 'Search';
export const GET_ANSWER_WITH_CHAT =
  'Have a question? Get quick answers with our chat service';
export const PARCEL_ISSUE = 'Parcel issue';
export const CHAT_WITH_US = 'Chat with us';
export const CHAT_TO_OUR_TEAM =
  'Chat to our Customer Service team. Monday-Friday: 8am-6:30pm';
export const WE_CAN_HELP_PARCEL_ISSUE =
  "If your parcel is damaged, missing, or hasn't arrived yet, we can help";
export const ENTER_YOUR_PARCEL_NUMBER =
  'Enter your parcel number and postcode for options';
export const ENTER_YOUR_TRACKING_DETAILS_BELOW =
  'Enter your tracking details below';
export const DAMAGED = 'Damaged';
export const MY_PARCEL_DAMAGED = 'My parcel has arrived damaged';
export const NOT_ARRIVED = 'Not Arrived';
export const MY_PARCEL_NOT_ARRIVED = "My parcel hasn't arrived";
export const MISSING_CONTENTS = 'Missing Contents';
export const MY_PARCEL_HAS_CONTENTS_MISSING = 'My parcel has contents missing';
export const YOUR_CONTACT_DETAILS = 'Your contact details';
export const TELL_ABOUT_PARCEL = 'Tell us about the parcel';
export const TELL_ABOUT_DAMAGE = 'Tell us about the damage';
export const YOUR_PARCEL_SUMMARY = 'Your parcel summary';
export const UPLOAD_FILES = 'Upload supporting files';
export const UPLOAD_IMAGES_OF_DAMAGE = 'Upload images of the damage';
export const CLICK_TO_UPLOAD = 'Click to upload';
export const DRAG_AND_DROP = 'or drag and drop';
export const ALLOWED_FORMATS_AND_SIZE = 'SVG, PNG, JPG, or GIF (max. 5MB)';
export const SUBMIT = 'SUBMIT';
export const OPEN_CHAT = 'OPEN CHAT';
export const YOUR_ENQUIRY_HAS_BEEN_PASSED =
  'Your enquiry has been passed to our team!';
export const WE_ARE_SORRY_TO_HEAR =
  'We are sorry to hear there has been a problem with your parcel. Our team will now look into this and take the necessary next steps. Once we have an update we will come back to you.';
export const UPLOAD_ERROR_IMAGE = 'An error occurred while uploading the image';
export const SEND_CLAIM_ERROR = 'An error occurred while submitting the claim';
export const CREATE_CASE_ERROR = 'An error occurred while creating the case';
export const CASE_CREATED_SUCCESS = 'The case has been created successfully';
export const CHAT_CONFIG_ERROR =
  'An error occurred while connecting to the chat';
export const PRICES_ERROR = 'An error occurred while getting the prices';
export const LIST_OF_UPLOAD_ERROR_IMAGE = {
  [ErrorCode.FileTooLarge]:
    'File is too large. Please upload a file smaller than 5MB',
  [ErrorCode.FileInvalidType]:
    'Invalid file type. Supported formats are SVG, PNG, JPG, or GIF',
  [ErrorCode.TooManyFiles]: 'You can upload up to 4 images. Please try again',
  default: 'Maximum upload limit executed. You can upload up to 4 images',
};
export const CHAT_UNAVAILABLE = 'Chat is currently unavailable';

export const HELP_LABELS = {
  PARCEL_REFERENCE_NUMBER: 'Parcel reference number',
  DELIVERY_POSTCODE_OR_ORDER_ID: 'Delivery post code / Order ID',
  COLLECTION_REFERENCE: 'Collection reference number',
  COLLECTION_POSTCODE: 'Collection post code',
  EMAIL_ADDRESS: 'Email address',
  CONTACT_NAME: 'Contact name',
  PHONE_NUMBER: 'Phone number',
  PARCEL_CONTENTS: 'Parcel contents',
  PARCEL_VALUE: 'Parcel value',
  PACKAGE_DESCRIPTION: 'Description of the packaging',
  ADDITIONAL_INFORMATION: 'Additional information',
  WHAT_MISSING: 'What is missing from the parcel?',
  DETAILED_DESCRIPTION:
    'Please provide a detailed description including any imei/serial/model numbers you have available',
  PACKAGE_DAMAGE: 'Is there any damage to the packaging?',
  MISSING_ITEM_VALUE: 'Missing Item Value',
  WHAT_DAMAGED: 'What has been damaged?',
  DAMAGE_DETAIL: 'Detail of the damage caused to the item',
  DAMAGED_ITEM_VALUE: 'Damaged Item Value',
};

export const HELP_PAGE_VALIDATION_MESSAGES = {
  COLLECTION_REFERENCE_IS_REQUIRED: 'Collection reference number is required',
  COLLECTION_REFERENCE_INVALID:
    'Collection reference number must be 11 digits long',
  PARCEL_CONTENTS: 'Please enter the contents of the parcel',
  PACKAGING_CONDITION: 'Please provide details about the packaging condition',
  DAMAGED_DESCRIPTION: 'Please include details of the damage',
  DAMAGED_ITEMS: 'Please describe what has been damaged',
  VALUE_DAMAGED: 'Enter the value of the damaged item',
  VALUE_NOT_ARRIVED: 'Please enter the value of the parcel',
  DESCRIPTION_OF_PACKAGING: 'Please enter a description of the packaging',
  ADDITIONAL_INFORMATION: 'Please provide additional information',
  MISSING_FROM_PARCEL: 'Please specify what is missing from the parcel',
  VALUE_GREATER_THAN: 'The value must be less than or equal to 1000',
};

export const CUSTOMS_PAGE = {
  TITLE: 'Customs',
  PARCEL_DETAILS: 'Tell us about your parcel contents',
  PROD_DESC_EXAMPLE: 'Example: Men’s patent leather shoes',
  TOTAL_QUANTITY_HELPER_TEXT: 'Total quantity of items for this parcel',
  PRODUCT_VALUE_HELPER_TEXT: 'The value of each product in this parcel',
  PRODUCT_WEIGHT_HELPER_TEXT_$: 'Max total weight per package is {0}kg',
  ENTER_OR_SELECT_COUNTRY_OF_ORIGIN: 'Enter or select the origin country',
  SAVE_PRODUCT: 'SAVE PRODUCT',
  ADD_ANOTHER_PRODUCT: 'ADD ANOTHER PRODUCT',
};

export const NETWORK_SHIP_TO_SHOP_KEY = '91';
export const COUNTRY_CODE = {
  UK: '+44',
};

//Content pages
export const PRICE_FROM_$ = 'From {0}{1}';
export const PRODUCTS_AND_SERVICES = 'Products & Services';
export const DOMESTIC = 'Domestic';
export const INTERNATIONAL = 'International';
export const PROHIBITED_LIST = 'Prohibited list';

// Billing Address
export const YOUR_BILLING_ADDRESS = 'Your Billing Address';
export const BILLING_ADDRESS = 'Billing Address';
export const SELECT_YOUR_BILLING_ADDRESS =
  'Please select your billing address *';
